module.exports = __webpack_public_path__ + "static/img/about02.5a43815.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/about02.png
// module id = Hb0L
// module chunks = 1